const updateUser = async ({ params, api }) => {
  const { previousData } = params;
  const { username } = previousData;
  return await api(`users/${username}`, { body: params.data, method: 'PUT' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default updateUser;